export const environment = {
  production: false,
  baseURL: 'https://admin.autoecare.com',
  loggingEnabled: true,
  envName: 'staging'
};
